<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!--Listes des Chantiers-->
    <v-layout row>
      <v-flex md12>
        <v-layout row>
          <v-card style="width:100%">
            <v-card-text fluid grid-list-md>
              <h4>LISTE DES CHANTIERS</h4>          
              <v-layout row>
                <v-flex sm12>
                  <data-tables :data="listeChantiers" :resizable="false">
                    <el-table-column prop="dateC"  width="98" label="Date">
                    </el-table-column>
                    <el-table-column
                      width="200"
                      prop="libelle"
                      label="Libelle"
                    ></el-table-column>
                    <el-table-column
                      prop="chefChantier"
                      label="Chef Chantier"
                    >
                    <template slot-scope="scope">
                        <v-chip outline text-color="orange" label> {{ scope.row.chefChantier }}</v-chip>                     
                    </template>
                    </el-table-column>
                    <el-table-column v-if='userAdmin'
                      prop="chefChantier"
                      label="Commis Chantier"
                    >
                    <template slot-scope="scope">
                          <span v-for="(item, index) in scope.row.commis" :key="index">
                              <v-chip outline text-color="green" label> {{ item }}</v-chip>/
                            </span>                         
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateD" width="98" label="Date Debut">
                    </el-table-column>
                    \
                    <el-table-column prop="dateF" width="98" label="Date Fin">
                    </el-table-column>
                    
                    <el-table-column
                      prop="evolution"
                      label="Evolution"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <v-progress-circular
                          :size="90"
                          :width="15"
                          :rotate="360"
                          :value="scope.row.evolution"
                          color="primary"
                        >
                          {{ scope.row.evolution }} %
                        </v-progress-circular>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="98"                      
                      prop="totalOuvriers"
                      label="nbre total d'ouvriers"
                    >
                      <template slot-scope="scope">
                        <el-tag type="warning">
                          {{ scope.row.totalOuvriers }}</el-tag
                        >
                      </template>
                    </el-table-column>

                    <!-- <el-table-column v-if="user.type == 1" prop="mntFacture" label="MontantTTC (Fcfa)" > </el-table-column> -->
                    <el-table-column
                      label="Action"
                      align="center"
                      fixed="right"
                    >

                      <template slot-scope="scope">
                        <v-tooltip top v-if="!commis">
                          <v-btn
                            slot="activator"
                            @click="newEquipe(scope.row)"
                            fab
                            dark
                            small
                            color="primary"
                          >
                            <v-icon dark>person_add</v-icon>
                          </v-btn>
                          Liste des ressources techniques...
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            @click="modalDetail(scope.row)"
                            fab
                            dark
                            small
                            color="blue"
                          >
                            <v-icon dark>list</v-icon>
                          </v-btn>
                          Détails...
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- DASHBOARD CHANTIER-->
    <DashboardChantier
      :detailChantier="detailChantier"
      :show="showDetailChantier"
      :commis="commis"
      @close="showDetailChantier = false"
    >
    </DashboardChantier>
    <!-- DASHBOARD CHANTIER -->

    <!--MODAL LISTE OUVRIERS -->
    <v-dialog
      v-model="showListOuvrier"
      :persistent="true"
      width="90%"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A CE CHANTIER:
            {{ chantierCourant.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="showListOuvrier = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h4 mt-2>LISTE DES OUVRIERS</h4>
          <v-flex xs12 class="text-xs-right">
            <v-tooltip top>
              <v-btn
                v-if="true"
                slot="activator"
                color="orange"
                @click.stop="openNewRessource()"
                dark
              >
                Ajouter
                <v-icon right>add</v-icon> </v-btn
              >Ajouter des ouvriers/prestataire
            </v-tooltip>
          </v-flex>
          <v-divider></v-divider>
          <v-layout row elevation-2>
            <v-flex sm12 mt-2>
              <data-tables
                mt-3
                ml-1
                mr-1
                :data="listeOuvriers"
                style="width:99%;"
              >
                <el-table-column
                  prop="idContrat"
                  label="Contrat"
                  align="center"
                  width="100"
                  fixed
                >
                  <template slot-scope="scope"
                    >CONT-{{ scope.row.idContrat }}</template
                  >
                </el-table-column>
                <!-- <el-table-column prop="travaux" label="Travaux" align="center" width="230" fixed></el-table-column>
                <el-table-column prop="taches" label="Taches" align="center" width="230" fixed></el-table-column> -->
                <el-table-column
                  prop="nom"
                  label="NOM"
                  align="center"
                  width="230"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="dateC"
                  label="DATE"
                  align="center"
                ></el-table-column>
                <el-table-column prop="dateD" label="Début"></el-table-column>
                <el-table-column prop="dateF" label="Fin"></el-table-column>
                <!-- <el-table-column prop="duree" label="Durée (Jours) "></el-table-column> -->
                <el-table-column
                  prop="montant"
                  label="MONTANT/HEURE"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="montantSupp"
                  label="MONTANT HEURE SUPP"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="etatContrat"
                  label="Etat contrat"
                  align="center"
                ></el-table-column>

              <el-table-column label="Action" fixed="right">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editRessources(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprTyp = true;
                          IdRessTeck = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>

              </data-tables>
            </v-flex>
          </v-layout>
          <br />
          <h4 mt-2>LISTE DES PRESTATAIRES</h4>
          <v-divider></v-divider>
          <v-layout row elevation-2>
            <v-flex sm12 mt-2>
              <data-tables
                mt-3
                ml-1
                mr-1
                :data="listePrestataires"
                style="width:99%;"
              >
                <el-table-column
                  prop="idContrat"
                  label="Contrat"
                  align="center"
                  width="100"
                  fixed
                >
                  <template slot-scope="scope"
                    >CONT-{{ scope.row.idContrat }}</template
                  >
                </el-table-column>
                <el-table-column
                  prop="nom"
                  label="NOM"
                  align="center"
                  width="230"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="dateC"
                  label="DATE"
                  align="center"
                ></el-table-column>
                <el-table-column prop="dateD" label="Début"></el-table-column>
                <el-table-column prop="dateF" label="Fin"></el-table-column>
                <!-- <el-table-column prop="duree" label="Durée (Jours) "></el-table-column> -->
                <el-table-column
                  prop="montant"
                  label="MONTANT/JOUR"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="montantSupp"
                  label="MONTANT HEURE SUPP"
                  align="center"
                ></el-table-column>

                <el-table-column
                  prop="etatContrat"
                  label="Etat contrat"
                  align="center"
                ></el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>

          <!--BOUTON VALIDATION-->
          <v-layout row class="text-xs-right"></v-layout>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!--MODAL LISTE OUVRIERS FIN -->

    <!-- MODAL AJOUT EQUIPE -->
    <v-dialog
      v-model="dialogEquipe"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit !== true">Définir les équipes</span>
            <span v-if="dialogEdit"
              >Modifier le contrat de {{ equipeCourant.executant }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogEquipe = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                v-if="dialogEdit !== true"
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                Attribuer des personnes à la tâche
                <v-icon right>person_add</v-icon>
              </v-chip>
              <v-chip
                v-if="dialogEdit"
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                Modification du contrat de
                {{ equipeCourant.executant }} concernant la tâche
                {{ equipeCourant.tache }}
                <v-icon right>person_add</v-icon>
              </v-chip>
            </p>

            <v-layout row v-if="dialogEdit !== true">
              <v-flex md4>
                <div class="block">
                  <span class="demonstration">Chantier concerné</span>
                  <el-input
                    :value="chantierCourant.libelle"
                    v-model="chantierCourant.libelle"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md4>
                <div class="block">
                  <span class="demonstration">Date de début</span>
                  <el-input
                    style="font-size:22px"
                    :value="chantierCourant.dateD"
                    v-model="chantierCourant.dateD"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md4>
                <div class="block">
                  <span class="demonstration">Date de fin</span>
                  <el-input
                    style="font-size:22px"
                    :value="chantierCourant.dateF"
                    v-model="chantierCourant.dateF"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <!-- <v-flex md3>
                <div class="block">
                  <span class="demonstration">Soustraitance</span>
                  <el-input
                    style="font-size:22px"
                    :value="chantierCourant.soutraiteLibelle"
                    v-model="chantierCourant.soutraiteLibelle"
                    disabled
                  ></el-input>
                </div>
              </v-flex> -->
            </v-layout>

            <!-- <v-layout row v-if="dialogEdit !== true">
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Sous-traitant</span>
                  <el-input
                    style="font-size:22px"
                    :value="chantierCourant.fournisseur"
                    v-model="chantierCourant.fournisseur"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
            </v-layout> -->

            <v-layout v-if="dialogEdit !== true" row>
              <v-flex md11>
                <p align="center">
                  <v-chip
                    text-color="white"
                    label
                    color="primary"
                    style="font-size:22px; width:100%"
                  >
                    Ajouter des lignes
                    <v-icon right>person_add</v-icon>
                  </v-chip>
                  <!--<v-alert-->
                  <!--:value="true"-->
                  <!--type="warning">-->
                  <!--<v-icon right>report</v-icon> Attention ! Veuillez saisir  des dates comprises dans l'interval du {{chantierCourant.dateDebut}} au {{chantierCourant.dateFin }} .-->

                  <!--</v-alert>-->
                </p>
              </v-flex>

              <v-flex md1>
                <v-btn
                  icons
                  color="primary"
                  @click="addOptionEquipe"
                  fab
                  small
                  dark
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-form
              v-model="valid"
              ref="formEquipe"
              lazy-validation
              id="formEquipe"
            >
              <v-container fluid grid-list-md>
                <v-layout row>
                  <v-btn
                    color="primary"
                    class="white--text"
                    @click="showDialogAjoutOuvrier()"
                  >
                    Ressources techniques
                    <v-icon right dark>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout
                  v-if="dialogEdit != true"
                  row
                  v-for="optionE in optionEquipe"
                  :key="optionE.key"
                >
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Type d'éxecutant</span>
                      <el-select
                        v-model="optionE.selectType"
                        placeholder="Type d'éxecutant"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in optionE.type"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3 v-if="optionE.selectType === 1">
                    <div class="block">
                      <span class="demonstration">Prestataire</span>
                      <el-select
                        clearable
                        filterable
                        v-model="optionE.fournisseur"
                        placeholder="Prestataire"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listPrestataire"
                          :key="item.idPres"
                          :label="item.libelle"
                          :value="item.idPres"
                        ></el-option>
                      </el-select>
                    </div>

                    <div class="block">
                      <span class="demonstration">Travaux</span>
                      <el-select
                        @change="filtrerTypeChantier()"
                        filterable
                        multiple
                        clearable
                        v-model="selectTravaux"
                        placeholder="Travaux"
                      >
                        <el-option
                          v-for="item in listTravaux"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="block" v-if="selectTravaux.length <= 1">
                      <span class="demonstration">Tache</span>
                      <el-select
                        filterable
                        multiple
                        clearable
                        v-model="selectTaches"
                        placeholder="Tache"
                      >
                        <el-option
                          v-for="item in listTaches.taches"
                          :key="item.id"
                          :label="item.tacheLibelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3 v-if="optionE.selectType === 2">
                    <div class="block">
                      <span class="demonstration">Ouvrier/Manoeuvre</span>
                      <el-select
                        clearable
                        filterable
                        v-model="optionE.ouvrier"
                        placeholder="Ouvrier/Manoeuvre"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listOuvrier"
                          :key="item.id"
                          :label="item.nom"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Durée</span>
                      <el-date-picker
                        name="duree"
                        range-separator="à"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="optionE.duree"
                        type="daterange"
                        start-placeholder="Date de début"
                        end-placeholder="Date de fin"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Montant/forfait (heure)</span>
                      <el-input
                        type="number"
                        required
                        :min="0"
                        v-model="optionE.montant"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Montant heures supplementaires</span>
                      <el-input
                        type="number"
                        :min="0"
                        v-model="optionE.montantSupp"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md1>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.prevent="removeOptionEquipe(optionE)"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon> </v-btn
                      >Supprimer
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="dialogEdit">
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Type d'exécutant</span>
                      <el-input
                        :value="equipeCourant.typeExec"
                        v-model="equipeCourant.typeExec"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Exécutant</span>
                      <el-input
                        :value="equipeCourant.executant"
                        v-model="equipeCourant.executant"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Date de début</span>
                      <el-date-picker
                        name="dateD"
                        value-format="dd-MM-yyyy"
                        v-model="dateDContrat"
                        type="date"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Date de fin</span>
                      <el-date-picker
                        name="dateF"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="dateFContrat"
                        type="date"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Montant / Jour</span>
                      <el-input
                        name="montant"
                        type="number"
                        :min="0"
                        v-model="montantContrat"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>

            <v-btn color="orange" @click.stop="dialogEquipe = false" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn
              v-if="dialogEdit !== true"
              icons
              color="primary"
              :disabled="loading"
              @click="submitEquipe()"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn
              v-if="
                dialogEdit &&
                  dateDContrat !== null &&
                  dateFContrat !== null &&
                  montantContrat !== 0
              "
              icons
              color="primary"
              @click="submitEquipe()"
              dark
            >
              Modifier
              <v-icon right>add</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW OUVRIER -->
    <v-dialog v-model="dialogAjoutOuvrier" persistent max-width="70%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>{{ editForm ? 'Modifier une ressources personnelles' : 'Ajouter une ressources personnelles' }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutOuvrier = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-container>
            <el-form
              label-position="right"
              :model="formManoeuvre"
              :rules="rulesformManoeuvre"
              ref="formManoeuvre"
              id="formManoeuvre"
              label-width="120px"
            >
              <el-row>
                <el-col :span="4" v-if="editForm">
                  <a :href="logoOuvrier" target="_blank">
                    <v-avatar
                      :tile="true"
                      size="140px"
                      height="120px"
                      color="grey lighten-4"
                    >
                      <img :src="logoOuvrier" alt="avatar"/></v-avatar
                    ><br />
                  </a>
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileOuvrier"
                    accept="image/*"
                    @change="onFileImageOuvrierPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileOuvrier.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </el-col>

                <el-col :span="18">
                  <el-row>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Matricule" prop="matricule">
                          <el-input
                            v-model="formManoeuvre.matricule"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Nom" prop="nom">
                          <el-input v-model="formManoeuvre.nom"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Domicile" prop="domicile">
                          <el-input v-model="formManoeuvre.domicile"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Profession" prop="profession">
                          <el-input
                            v-model="formManoeuvre.profession"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Type de piece" prop="piece">
                          <el-input v-model="formManoeuvre.piece"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="numéro de pièce" prop="numPiece">
                        <el-input v-model="formManoeuvre.numPiece"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="Contact" prop="contact">
                        <el-input v-model="formManoeuvre.contact"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="Date de naissance" prop="dateNaiss">
                        <el-date-picker
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Date de naissance"
                          v-model="formManoeuvre.dateNaiss"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>

                    <!-- pour la modification des info -->
                    <el-col :span="12" v-if="editForm">
                      <el-form-item label="Date de debut" prop="dateD">
                        <el-date-picker
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Date de debut"
                          v-model="formManoeuvre.dateD"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" v-if="editForm">
                      <el-form-item label="Date de fin" prop="dateD">
                        <el-date-picker
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Date de fin"
                          v-model="formManoeuvre.dateF"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    
                    <el-col :span="12" v-if="editForm">
                      <el-form-item label="Montant/forfait (Heure)" prop="montant">
                        <el-input
                        type="number"
                        required
                        :min="0"
                        v-model="formManoeuvre.montant"                        
                      ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" v-if="editForm">
                      <el-form-item label="Montant heures supplementaires" prop="montantSupp">
                        <el-input
                        type="number"
                        required
                        :min="0"
                        v-model="formManoeuvre.montantSupp"                        
                      ></el-input>
                      </el-form-item>
                    </el-col>

                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialogAjoutOuvrier = false">Fermer</v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            dark
            @click="submitformManoeuvre('formManoeuvre')"
            >Enregistrer<v-icon right>save</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

        <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSuprTyp"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprTyp = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteType" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import Loading from "@/components/Loading";
import DashboardChantier from "@/components/boardChantier/dashboard_chantier";

export default {
  components: { Loading, DashboardChantier },
  name: "Chantier_index",
  props: {
    listeChantiers: {
      type: Array
    },
    userAdmin: {
      type: Boolean
    },
    commis: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      detailChantier: {},
      valid: true,
      dialogEdit: false,
      showDetailChantier: false,
      dialogEquipe: false,
      dialogAjoutOuvrier: false,
      editForm:false,
      logoOuvrier: "/static/img-doc.png",

      listTravaux: [],
      listTaches: [],
      selectTravaux: [],
      selectTaches: [],
      dialogSuprTyp: false,
      IdRessTeck:'',

      totalChantEnCours: 0,
      totalChantEnArret: 0,
      totalChantTermine: 0,
      chantierCourant: [],
      equipeCourant: [],
      showListOuvrier: false,
      listeOuvriers: [],
      listOuvrier: [],
      optionE: [],
      listePrestataires: [],
      selectType: "",
      formManoeuvre: {
        nom: "",
        matricule: "",
        domicile: "",
        profession: "",
        piece: "",
        numPiece: "",
        contact: "",
        dateNaiss: "",
        dateD: "",
        dateF: "",
        montant: "",
        montantSuppN: "",
        montantSupp: "",
        id: ""
      },
      rulesformManoeuvre: {
        nom: [{ required: true, message: "Saisir un nom", trigger: "blur" }],
        matricule: [
          { required: true, message: "Saisir un matricule", trigger: "blur" }
        ],
        piece: [
          {
            required: true,
            message: "Saisir le type de piece",
            trigger: "blur"
          }
        ],
        numPiece: [
          {
            required: true,
            message: "Saisir le numero de la piece",
            trigger: "blur"
          }
        ],
        contact: [
          {
            required: true,
            message: "Saisir un numéro de téléphone",
            trigger: "blur"
          }
        ]
      },
      optionEquipe: [
        {
          key: 1,
          type: [
            { text: "Prestataire", value: 1 },
            { text: "Ouvrier/Manoeuvre", value: 2 }
          ],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        }
      ]
    };
  },
  computed: {},
  watch: {
    listeChantiers: function(newValue, oldValue) {
      this.totalChantEnCours = 0;
      this.totalChantEnArret = 0;
      this.totalChantTermine = 0;
      this.listeChantiers.forEach(elt => {
        if (elt.etat == 1) {
          this.totalChantEnCours++;
        } else if (elt.etat == 2) {
          this.totalChantEnArret++;
        } else if (elt.etat == 3) {
          this.totalChantTermine++;
        }
      }, this);
    }
  },
  imprimeChaniter(idEtat = 0) {
    let url = this.domaine + "mission/impression/liste/" + idEtat;
    window.open(url);
  },
  methods: {
    modalDetail(item) {
      this.detailChantier = item;
      this.showDetailChantier = true;
    },

    editRessources(item) {
      console.log('item',item)
      this.dialogAjoutOuvrier = true
      this.editForm = true;
      this.formManoeuvre.matricule = item.matricule;
      this.formManoeuvre.nom = item.nom;
      this.formManoeuvre.domicile = item.domicile;
      this.formManoeuvre.profession = item.profession;
      this.formManoeuvre.contact = item.contact;
      this.formManoeuvre.piece = item.piece;
      this.formManoeuvre.numPiece = item.numPiece;
      const dateNaissISO = item.dateNaiss.split('-').reverse().join('-');
      this.formManoeuvre.dateNaiss = new Date(dateNaissISO)      
      this.formManoeuvre.id = item.id;
      const dateDISO = item.dateD.split('-').reverse().join('-');
      const dateFISO = item.dateF.split('-').reverse().join('-');

      this.formManoeuvre.dateD = new Date(dateDISO)      
      this.formManoeuvre.dateF = new Date(dateFISO)      
      this.formManoeuvre.montant = item.montantN;
      this.formManoeuvre.montantSupp = item.montantSuppN;
    },
    deleteType() {
        this.loading = true;
        let url = this.domaine + "ouvrier/" + this.IdRessTeck + "/chantier/"+this.chantierCourant.id 
        this.$http.get(url).then(response => {
          this.loading = false;
          this.$notify({
              title: "SUPPRESSION",
              message: response.message,
              type: "warning",
              position: "top-center"
            });
          this.dialogSuprTyp = false;
          this.loadListeOuvrier(this.chantierCourant.id);
        });
      },
      
    newEquipe(item) {
      this.showListOuvrier = true;
      this.chantierCourant = item;
      this.loadListeOuvrier(item.id);
    },
    addOptionEquipe() {
      if (this.chantierCourant.soutraite == 1) {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }],
          selectType: 1,
          fournisseur: this.chantierCourant.idFour,
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          selectTravaux: [],
          selectTaches: [],
          id: ""
        });
      } else {
        this.optionEquipe.push({
          key: Date.now(),
          type: [
            { text: "Prestataire", value: 1 },
            { text: "Manoeuvre", value: 2 }
          ],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      }

      this.totComLigneTTC += 5;
    },
    onFileImageOuvrierPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoOuvrier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoOuvrier = files[0];
    },
    submitformManoeuvre(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          // enregistrement des ouvriers
          
          let url = this.domaine + (this.editForm ? "ouvrier/edit/"+this.formManoeuvre.id : "ouvrier/new");
          var form = document.getElementById("formManoeuvre");
          var data = new FormData(form);

          data.append("nom", this.formManoeuvre.nom);
          data.append("matricule", this.formManoeuvre.matricule);
          data.append("domicile", this.formManoeuvre.domicile);
          data.append("profession", this.formManoeuvre.profession);
          data.append("piece", this.formManoeuvre.piece);
          data.append("contact", this.formManoeuvre.contact);
          data.append("numPiece", this.formManoeuvre.numPiece);
         
            console.log(data);

            console.log('ici');

          if(this.editForm) {
            data.append("montant", this.formManoeuvre.montant);
            data.append("montantSupp", this.formManoeuvre.montantSupp);
            data.append("chantier", this.chantierCourant.id);
            const dateNaissISO = new Date(this.formManoeuvre.dateNaiss).toISOString().split('T')[0];            
            const dateFISO = new Date(this.formManoeuvre.dateF).toISOString().split('T')[0];
            const dateDISO = new Date(this.formManoeuvre.dateD).toISOString().split('T')[0];
            data.append("dateD", dateDISO);
            data.append("dateNaiss", dateNaissISO);
            data.append("dateF", dateFISO);
          }else {
            data.append("dateNaiss", this.formManoeuvre.dateNaiss);
          }

          // else {
          //   data.append("dateNaiss", this.formManoeuvre.dateNais);
          // }
          this.$http.post(url, data).then(
            response => {
              if(this.editForm) { 
                this.loadListeOuvrier(this.chantierCourant.id);
              }else {
                this.loadOuvrier();
              }

              this.loading = false;
              this.dialogAjoutOuvrier = false;
              this.$message({
                message: "L'enregistrement sest deroule avec succes ",
                type: "success"
              });
            },
            response => {
              this.loading = false;
              this.$message.error(
                "Erreur lors de l'enregistrement d'un manoeuvre "
              );
            }
          );
        }
      });
    },
    submitEquipe() {
      this.loading = true;
      if (this.$refs.formEquipe.validate()) {
        let etat = false;
        var form = document.getElementById("formEquipe");
        var data = new FormData(form);
        let url = "";
        // if (this.chantierCourant.id != "") {
        //   url =
        //     this.domaine + "projet/" + this.chantierCourant.id + "/edit/contrat";
        //   etat = true;
        // } else {
        url =
          this.domaine + "projet/" + this.chantierCourant.id + "/new/equipe";
        let ligne = null;
        for (let prop in this.optionEquipe) {
          ligne = this.optionEquipe[prop];

          // date selectionnée
          let tabDateFin = ligne.duree[1].split("-"); //["16","08","2018 00:00:00"]
          let jr = tabDateFin[0];
          let mois = tabDateFin[1];
          let annee = tabDateFin[2].split(" ")[0];
          let dateFin = annee + "-" + mois + "-" + jr;
          let dateChtFin = new Date(dateFin);
          // date de fin du chantier
          let tabDateFinC = this.chantierCourant.dateF.split("-"); //["16","08","2018 00:00:00"]
          let jrC = tabDateFinC[0];
          let moisC = tabDateFinC[1];
          let anneeC = tabDateFinC[2].split(" ")[0];
          let dateFinC = anneeC + "-" + moisC + "-" + jrC;
          let dateChtFinC = new Date(dateFinC);

          // on vérifie si la date de fin du chantier est plus inferieur a la date de fin selectionné
          if (dateChtFin > dateChtFinC) {
            this.$notify({
              title: "ATTENTION",
              message:
                "La durée doit etre comprise dans le durée du chantier .",
              type: "warning",
              position: "top-center"
            });
          } else {
            if (
              (ligne.selectType !== null &&
                ligne.duree !== null &&
                ligne.ouvrier !== null) ||
              ligne.fournisseur !== ""
            ) {
              etat = true;
              data.append("option[id][]", ligne.id);
              data.append("option[type][]", ligne.selectType);
              data.append("option[ouvrier][]", ligne.ouvrier);
              data.append("option[fournisseur][]", ligne.fournisseur);
              data.append("option[duree][]", ligne.duree);
              data.append("option[montant][]", ligne.montant);
              data.append("option[montantSupp][]", ligne.montantSupp);
            } else {
              etat = false;
            }
          }
        }
        // }
        data.append("idUser", this.user.id);
        data.append("listTaches", this.selectTaches);
        data.append("listTravaux", this.selectTravaux);
        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  if (this.chantierCourant.id) {
                    this.$notify({
                      title: "ENREGISTREMENT REUSSI",
                      message: "Equipe enregistré avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  } else {
                    this.$notify({
                      title: "MODIFICATION REUSSI",
                      message: "Contrat modifié avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  }

                  // this.loadChantier(this.projetCourant);
                  // this.loadEquipe(this.travauxCourant);
                  this.loadListeOuvrier(this.chantierCourant.id);
                  this.dialogEquipe = false;
                  this.loading = false;
                  this.$refs.formEquipe.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error(
                  "Une erreur est survenue. Veuillez contacter votre administrateur"
                );
                this.loading = false;
              }
            },
            response => {
              this.$message.error(
                "Une erreur est survenue. Veuillez contacter votre administrateur"
              );
              this.loading = false;
            }
          );
        } else {
          // this.$notify({
          //   title: "ATTENTION",
          //   message: "Veuillez renseigner correctement tout les champs.",
          //   type: "warning",
          //   position: "top-center"
          // });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadPrestaire() {
      this.loading = true;
      let url = this.domaine + "fournisseur/listePrestataire/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listPrestataire = response.body.prestataire;
          this.loading = false;
        }
      });
    },
    loadOuvrier() {
      let url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listOuvrier = response.body.ouvrier;
        }
      });
    },
    openNewRessource() {
      this.dialogEquipe = true;
      (this.selectTravaux = []), (this.selectTaches = []), (this.optionE = []);
      (this.optionEquipe = [
        {
          key: 1,
          type: [
            { text: "Prestataire", value: 1 },
            { text: "Ouvrier/Manoeuvre", value: 2 }
          ],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        }
      ]),
        this.loadPrestaire();
      this.loadOuvrier();
      this.loadTravaux(this.chantierCourant);
    },
    showDialogAjoutOuvrier() {
      this.dialogAjoutOuvrier = true;
      this.editForm = false
      this.formManoeuvre.matricule = "";
      this.formManoeuvre.nom = "";
      this.formManoeuvre.domicile = "";
      this.formManoeuvre.profession = "";
      this.formManoeuvre.contact = "";
      this.formManoeuvre.piece = "";
      this.formManoeuvre.numPiece = "";
      this.formManoeuvre.dateNaiss = "";
      this.formManoeuvre.dateD = ""
      this.formManoeuvre.dateF = ""
      this.formManoeuvre.montant = ""
      this.formManoeuvre.montantSupp = ""
      
      this.logoOuvrier = "/static/img-doc.png";
      this.optionE.selectType = "";
      this.optionE.fournisseur = "";
      this.optionE.ouvrier = "";
      this.optionE.duree = "";
      this.optionE.montant = "";
      this.optionE.montantSupp = "";
    },
    loadListeOuvrier(idChantier) {
      this.loading = true;
      let url = "";
      // if(tache.idOpt) {
      //   url = this.domaine + "ouvrier/optionTravaux/" + tache.idOpt;
      // }else{
      url = this.domaine + "ouvrier/chantier/" + idChantier;

      // }

      this.$http.get(url).then(
        response => {
          this.listeOuvriers = response.body.ouvriers;
          this.listePrestataires = response.body.prestataires;
          // this.listePrestOuvriers = response.body.listePresOuvriers;
          this.listePresence = response.body.listePresence;
          // this.dialogOuvrier = true;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des ouvriers");
        }
      );
    },
    loadTravaux(chantierCourant) {
      this.loading = true;
      let url = "";
      url =
        this.domaine +
        "projet/" +
        chantierCourant.id +
        "/index/chantier/travaux";
      this.$http.get(url).then(
        response => {
          this.listTravaux = response.body.travaux;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des ouvriers");
        }
      );
    },
    filtrerTypeChantier() {
      this.selectTaches = [];
      if (this.selectTravaux.length == 1) {
        let url = "";
        url =
          this.domaine +
          "projet/chantier/" +
          this.chantierCourant.id +
          "/travaux/" +
          this.selectTravaux[0] +
          "/taches";
        this.$http.get(url).then(
          response => {
            this.listTaches = response.body.taches;
            this.loading = false;
          },
          error => {
            this.loading = false;
            this.$message.error("Echec lors du chargement des ouvriers");
          }
        );
      }
    },
    removeOptionEquipe(item) {
      var index = this.optionEquipe.indexOf(item);
      if (index !== -1) {
        this.optionEquipe.splice(index, 1);
      }
    }
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/boardChantier/Chantier_index.vue